export enum RecurrenceOptions {
  IMMEDIATELY = 1,
  DAILY = 2,
  WEEKLY = 3,
  MONTHLY = 4,
}

export enum WeekDays {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 0,
}

export enum FrequencyOptions {
  DAY = 0,
  FIRST = 1,
  SECOND = 2,
  THIRD = 3,
  FOURTH = 4,
  LAST = 5,
}
